var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"layout full row"},[_c('work-menu',{staticClass:"work-menu"}),_c('div',{staticClass:"col-span col rightHeight",staticStyle:{"overflow-y":"auto"}},[_c('work-header',{staticClass:"work-header"}),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }